export default __webpack_public_path__ + "static/media/homepage_bg.070f5974.png";